import { create } from "zustand";
import {
  type Song,
  listSongs,
  listSongsByBand,
  createSong as apiCreate,
  updateSong as apiUpdate,
} from "../infra/api.js";

interface SongState {
  songs: Song[];
  loading: boolean;
  error: string | null;
  fetchAll: (withAudioOnly?: boolean) => Promise<void>;
  fetchByBand: (bandId: string) => Promise<void>;
  create: (input: { bandId?: string; title?: string }) => Promise<Song>;
  update: (projectId: string, input: { bandId?: string | null; title?: string }) => Promise<Song>;
}

export const useSongStore = create<SongState>((set, get) => ({
  songs: [],
  loading: false,
  error: null,

  async fetchAll(withAudioOnly) {
    set({ loading: true, error: null });
    try {
      const filter: { withAudio?: boolean } = {};
      if (withAudioOnly) filter.withAudio = true;
      const { songs } = await listSongs(filter);
      set({ songs, loading: false });
    } catch (e) {
      set({ error: e instanceof Error ? e.message : String(e), loading: false });
    }
  },

  async fetchByBand(bandId) {
    set({ loading: true, error: null });
    try {
      const { songs } = await listSongsByBand(bandId);
      set({ songs, loading: false });
    } catch (e) {
      set({ error: e instanceof Error ? e.message : String(e), loading: false });
    }
  },

  async create(input) {
    const { song } = await apiCreate(input);
    set({ songs: [song, ...get().songs] });
    return song;
  },

  async update(projectId, input) {
    const { song } = await apiUpdate(projectId, input);
    set({ songs: get().songs.map((s) => (s.project_id === projectId ? song : s)) });
    return song;
  },
}));
